<template>
  <v-container v-if="organization" fluid>
    <!-- General Info -->
    <v-card flat class="outlined mb-4">
      <v-card-text>
        <h2 class="mb-3 h2-header">{{ $t("pageHeader.general") }}</h2>

        <v-row>
          <v-col cols="12" sm="6">
            <span class="font-weight-medium"
              >{{ $t("labels.organizationName") }}:</span
            >
            {{ organization.name }}
          </v-col>

          <v-col cols="12" sm="6">
            <span class="font-weight-medium"
              >{{ $t("labels.referralCode") }}:</span
            >
            {{ organization.ReferralCode }}
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- PDF Embed Toggle -->
        <h3 class="mb-2">Embed PDF</h3>
        <p class="text-body-2">
          Uses the browser's internal PDF viewer to display receipts and
          reports. Enabling this may improve performance on desktop devices but
          limit some features.
        </p>
        <v-switch
          v-model="embedPDF"
          color="primary"
          inset
          :label="embedPDF ? 'Enabled' : 'Disabled'"
        />
      </v-card-text>
    </v-card>

    <!-- Revenue Calculation (optional block, uncomment if needed) -->
    <!--
    <v-card flat class="outlined">
      <v-card-text>
        <h3 class="mb-3">{{ $t('labels.revenue') }}</h3>
        <v-row align="center">
          <v-col cols="12" md="9">
            <p class="text-body-2">
              Calculate revenue based on expected invoices or actual payment received:
            </p>
            <ul class="ml-4">
              <li><b>Expected:</b> Count invoice total amount into revenue.</li>
              <li><b>Actual:</b> Count only payments received into revenue.</li>
            </ul>
          </v-col>
          <v-col cols="12" md="3" class="text-right">
            <v-switch
              v-model="organization.metadata.calculationByRevenue"
              color="primary"
              :label="organization.metadata.calculationByRevenue ? 'Expected' : 'Actual'"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          
          dark
          class="v-btn-with-radius"
          @click.stop.prevent="update"
        >
          {{ $t('buttons.update') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    -->
  </v-container>
</template>

<script>
import organizationService from "../../../Organization/service.js";

export default {
  name: "settings-general",
  data() {
    return {
      organization: null,
      metadata: {
        calculationByRevenue: false,
      },
    };
  },
  created() {
    organizationService
      .getCurrent()
      .then((response) => {
        this.organization = response.data;
        this.organization.metadata = {
          ...this.metadata,
          ...this.organization.metadata, // keep existing values
        };
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    embedPDF: {
      get() {
        return this.$store.getters["settings/embedPDF"];
      },
      set(val) {
        this.$store.dispatch("settings/toggleEmbedPDF", val);
      },
    },
  },
  methods: {
    update() {
      organizationService
        .update(this.organization.id, {
          name: this.organization.name,
          email: this.organization.email,
          metadata: this.organization.metadata,
        })
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              showConfirmButton: true,
              position: "top-end",
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: this.$t("toastMessage.text.updated"),
            });
        });
    },
  },
};
</script>